import { render, staticRenderFns } from "./infojabatan.vue?vue&type=template&id=5b4352a7"
import script from "./infojabatan.vue?vue&type=script&lang=js"
export * from "./infojabatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports